module.exports = __webpack_public_path__ + "static/media/GebietskarteNetzbetrieb.c9974d25.pdf";